
import { CurrencyType } from "@wg/wows-react-uikit/Currency";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { State } from "../../types/State";
import { fetchMembers } from "../Actions/ActionClanProfile";
import {
  appendTransactions,
  distributeResources,
  hideDistributionDialog,
  hideDistributionResultDialog,
  init,
  repeatFailedDistribution,
  selectDistributionCurrency,
  setDistributionFilter,
  setDistributionSum,
  setFilterDates,
  setSelectedTab,
  setSortField,
  showDistributionDialog,
  showDistributionResultDialog,
  toggleDistributionMembers,
  toggleIsDistributionFilterVisible,
  navigateToTreasuryBuilding,
  repeatTreasuryBoxTransaction
} from "../Actions/ActionTreasury";
import ViewTreasury from "../Components/ViewTreasury/ViewTreasury";
import { Balance, IDateFormats, Transaction, Transactions } from "../Reducers/ReducerTreasury";
import { syncAccountInfo } from '../Actions/ActionAccount'

export type ContainerTreasury_Props = {
  transactions: Transactions;
  selectedTab: number;
  isDistributionVisible: boolean;
  filterStartDate: moment | null;
  filterEndDate: moment | null;
  totalBalanceList: Balance;
  totalTransactionsSum: Balance;
  clanId: number;
  members: Array<any>; // TODO add Member description
  distributionList: Array<number>;
  distributionSum: number;
  selectedDistributionCurrency: CurrencyType;
  isTotalTransactionsSumUpdating: boolean;
  isTransactionListUpdating: boolean;
  permissions: Array<string>;
  isDistributionResultDialogVisible: boolean;
  detailViewTransaction: Transaction | null;
  isAppending: boolean;
  id: number;
  distributionPlayerFilter: string;
  isDistributionFilterInputVisible: boolean;
  sortDirection: null | "ask" | "desk";
  sortField: string | null;
  languageCode: string;
  formats: IDateFormats;
  treasuryMinDistributionSumm: number;
  treasuryMinDaysInClan: number;
  root: string,

  selectDistributionCurrency: (type: CurrencyType) => void;
  init: () => void;
  setSelectedTab: (index: string | number) => void;
  showDistributionDialog: () => void;
  hideDistributionDialog: () => void;
  setFilterDates: (start: moment, end: moment) => void;
  fetchMembers: (clanId: number) => void;
  toggleDistributionMembers: (members: Array<any>, toggleAll: boolean) => void;
  setDistributionSum: (sum: number) => void;
  distributeResources: () => void;
  hideDistributionResultDialog: () => void;
  showDistributionResultDialog: (transaction: Transaction) => void;
  appendTransactions: () => void;
  repeatFailedDistribution: () => void;
  setDistributionFilter: (value: string) => void;
  toggleIsDistributionFilterVisible: () => void;
  setSortField: (field: string) => void;
  navigateToTreasuryBuilding: () => void,
  syncAccountInfo: () => void,
};

export type ContainerTreasury_State = {};
class ContainerTreasury extends Component<ContainerTreasury_Props, ContainerTreasury_State> {


  componentDidMount() {
    this.props.init();
    this.props.syncAccountInfo()
  }

  setSelectedTab = (selectedTab: number) => {
    switch (selectedTab) {
      case 0: {
        this.props.router.push(`${this.props.root}treasury/expenses`)
        break
      }
      case 1: {
        this.props.router.push(`${this.props.root}treasury/income`)
        break
      }
      case 2: {
        this.props.router.push(`${this.props.root}treasury/distribution`)
        break
      }
      case 3: {
        this.props.router.push(`${this.props.root}treasury/regularRewards`)
        break
      }
      default: {
        break
      }
    }
  }

  render() {
    return (
      <ViewTreasury
        transactions={this.props.transactions}
        selectedTab={this.props.selectedTab}
        isDistributionVisible={this.props.isDistributionVisible}
        filterStartDate={this.props.filterStartDate}
        filterEndDate={this.props.filterEndDate}
        totalBalanceList={this.props.totalBalanceList}
        totalTransactionsSum={this.props.totalTransactionsSum}
        clanId={this.props.clanId}
        members={this.props.members}
        distributionList={this.props.distributionList}
        distributionSum={this.props.distributionSum}
        selectedDistributionCurrency={this.props.selectedDistributionCurrency}
        isTotalTransactionsSumUpdating={this.props.isTotalTransactionsSumUpdating}
        isTransactionListUpdating={this.props.isTransactionListUpdating}
        permissions={this.props.permissions}
        isDistributionResultDialogVisible={this.props.isDistributionResultDialogVisible}
        detailViewTransaction={this.props.detailViewTransaction}
        isAppending={this.props.isAppending}
        id={this.props.id}
        distributionPlayerFilter={this.props.distributionPlayerFilter}
        isDistributionFilterInputVisible={this.props.isDistributionFilterInputVisible}
        sortDirection={this.props.sortDirection}
        sortField={this.props.sortField}
        languageCode={this.props.languageCode}
        formats={this.props.formats}
        treasuryMinDistributionSumm={this.props.treasuryMinDistributionSumm}
        treasuryMinDaysInClan={this.props.treasuryMinDaysInClan}
        regularRewards={this.props.regularRewards}

        setSelectedTab={this.setSelectedTab}
        showDistributionDialog={this.props.showDistributionDialog}
        hideDistributionDialog={this.props.hideDistributionDialog}
        setFilterDates={this.props.setFilterDates}
        fetchMembers={this.props.fetchMembers}
        toggleDistributionMembers={this.props.toggleDistributionMembers}
        setDistributionSum={this.props.setDistributionSum}
        selectDistributionCurrency={this.props.selectDistributionCurrency}
        distributeResources={this.props.distributeResources}
        hideDistributionResultDialog={this.props.hideDistributionResultDialog}
        showDistributionResultDialog={this.props.showDistributionResultDialog}
        appendTransactions={this.props.appendTransactions}
        repeatFailedDistribution={this.props.repeatFailedDistribution}
        setDistributionFilter={this.props.setDistributionFilter}
        toggleIsDistributionFilterVisible={this.props.toggleIsDistributionFilterVisible}
        setSortField={this.props.setSortField}
        navigateToTreasuryBuilding={this.props.navigateToTreasuryBuilding}
        repeatTreasuryBoxTransaction={this.props.repeatTreasuryBoxTransaction}
      />
    )
  }
}

const mapStateToProps = (state: State) => {

  const clan = state.clans.items[state.currentAccount.clanId]
  const personalResource = (clan && clan.personalResource) ? clan.personalResource : 0

  let balance = state.ReducerTreasury.totalBalanceList.filter((resource) => resource.type !== 'oil')
  balance.push({ type: 'oil', amount: personalResource, canDistribute: false })


  return {
    transactions: state.ReducerTreasury.transactions,
    selectedTab: state.ReducerTreasury.selectedTab,
    isDistributionVisible: state.ReducerTreasury.isDistributionVisible,
    filterStartDate: state.ReducerTreasury.filterStartDate,
    filterEndDate: state.ReducerTreasury.filterEndDate,
    totalBalanceList: balance,
    totalTransactionsSum: state.ReducerTreasury.totalTransactionsSum,
    clanId: state.currentAccount.clanId,
    members: state.members.clans[state.currentAccount.clanId] ? state.members.clans[state.currentAccount.clanId].members : [],
    distributionList: state.ReducerTreasury.distributionList,
    distributionSum: state.ReducerTreasury.distributionSum,
    selectedDistributionCurrency: state.ReducerTreasury.selectedDistributionCurrency,
    isTotalTransactionsSumUpdating: state.ReducerTreasury.isTotalTransactionsSumUpdating,
    isTransactionListUpdating: state.ReducerTreasury.isTransactionListUpdating,
    permissions: state.currentAccount.permissions,
    isDistributionResultDialogVisible: state.ReducerTreasury.isDistributionResultDialogVisible,
    detailViewTransaction: state.ReducerTreasury.detailViewTransaction,
    isAppending: state.ReducerTreasury.isAppending,
    id: state.currentAccount.id,
    distributionPlayerFilter: state.ReducerTreasury.distributionPlayerFilter,
    isDistributionFilterInputVisible: state.ReducerTreasury.isDistributionFilterInputVisible,
    sortDirection: state.ReducerTreasury.sortDirection,
    sortField: state.ReducerTreasury.sortField,
    languageCode: state.settings.realm.languageCode,
    formats: state.settings.formats,
    treasuryMinDistributionSumm: state.settings.treasuryMinDistributionSumm,
    treasuryMinDaysInClan: state.settings.treasuryMinDaysInClan,
    root: state.urls.root,
    regularRewards: state.ReducerTreasury.regularRewards,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    syncAccountInfo: () => {
      dispatch(syncAccountInfo())
    },
    init: () => {
      dispatch(init());
    },
    showDistributionDialog: () => {
      dispatch(showDistributionDialog());
    },
    hideDistributionDialog: () => {
      dispatch(hideDistributionDialog());
    },
    setSelectedTab: index => {
      dispatch(setSelectedTab(index));
    },
    setFilterDates: (start: moment, end: moment) => {
      dispatch(setFilterDates(start, end));
    },
    fetchMembers: (clanId: number) => {
      dispatch(fetchMembers(clanId));
    },
    toggleDistributionMembers: (members: Array<any>, toggleAll: boolean) => {
      dispatch(toggleDistributionMembers(members, toggleAll));
    },
    setDistributionSum: (number: number) => {
      dispatch(setDistributionSum(number));
    },
    selectDistributionCurrency: (type: CurrencyType) => {
      dispatch(selectDistributionCurrency(type));
    },
    distributeResources: () => {
      dispatch(distributeResources());
    },
    hideDistributionResultDialog: () => {
      dispatch(hideDistributionResultDialog());
    },
    showDistributionResultDialog: (transaction: Transaction) => {
      dispatch(showDistributionResultDialog(transaction));
    },
    appendTransactions: () => {
      dispatch(appendTransactions());
    },
    repeatFailedDistribution: () => {
      dispatch(repeatFailedDistribution());
    },
    setDistributionFilter: (value: string) => {
      dispatch(setDistributionFilter(value));
    },
    toggleIsDistributionFilterVisible: () => {
      dispatch(toggleIsDistributionFilterVisible());
    },
    setSortField: (field: string) => {
      dispatch(setSortField(field));
    },
    navigateToTreasuryBuilding: () => {
      dispatch(navigateToTreasuryBuilding())
    },
    repeatTreasuryBoxTransaction: (id) => {
      dispatch(repeatTreasuryBoxTransaction(id))
    },

  };
};

export default translate()(connect(mapStateToProps, mapDispatchToProps)(ContainerTreasury));